import { getCanvas } from '../../utils/mapUtils';
import { states, isChannel60Ghz } from './leafletCanvas';
import getFeatureStyle from './getFeatureStyle';
import { HandleDragging } from './apHandles';
import { store } from '../../store';
import { errorToast, postWithAuth } from '../../api';

/**
 * Feature click handler
 */
export const clickHandler = (event) => {
  const canvas = getCanvas();
  if (new HandleDragging().interceptPostDragClick()) {
    return;
  }
  if (canvas.state !== states.MAP_SELECT) {
    return;
  }
  canvas.map.doubleClickZoom.disable();
  const { target, latlng } = event;
  const { lat, lng } = latlng;
  const feature = target.feature;
  const features = canvas.hittest(lat, lng, feature.properties.kind);
  //   console.log(features.forEach((f) => console.log(f.properties.name)));
  canvas.setMultipleSelection(feature, features);
  canvas.map.doubleClickZoom.enable();
};

export const apClickHandler = (event) => {
  const canvas = getCanvas();
  if (new HandleDragging().interceptPostDragClick()) {
    return;
  }
  if (isChannel60Ghz()) {
    canvas.map.doubleClickZoom.disable();

    const eq = store.getState().map.channel60GHzChoice;
    const { target, latlng } = event;
    const { lat, lng } = latlng;
    const feature = target.feature;
    if (
      canvas.state === states.MAP_60GHZ_CHANNEL_PLAN_EDIT &&
      (eq.channel != null || eq.polarity != null)
    ) {
      // 60GHz channel planning edit mode
      const projectId = store.getState().mainFrame.projectId;
      event.target.removeFrom(canvas.map);
      feature.properties.dirty = true;
      event.target.addTo(canvas.map);
      postWithAuth(
        `project/${projectId}/access_point/channel_planning/edit`,
        {
          end_id: feature.properties.id,
          name: feature.properties.name,
          channel: eq.channel,
          polarity: eq.polarity,
        },
        'PATCH'
      ).catch(() => {
        errorToast('Failed to update the network device.');
        feature.properties.dirty = false;
      });
    } else {
      const features = canvas.hittest(lat, lng, feature.properties.kind);
      canvas.setMultipleSelection(feature, features);
    }

    canvas.map.doubleClickZoom.enable();
    return;
  } else if (canvas.state !== states.MAP_SELECT) {
    return;
  }

  canvas.map.doubleClickZoom.disable();
  const { target, latlng } = event;
  const { lat, lng } = latlng;
  const feature = target.feature;
  const features = canvas.hittest(lat, lng, feature.properties.kind);
  canvas.setMultipleSelection(feature, features);

  canvas.map.doubleClickZoom.enable();
};

const allowHighlight = (kind) => {
  const canvas = getCanvas();
  const state = canvas.state;
  if (state === states.MAP_SELECT) {
    return true;
  } else if (
    kind === 'network_site' &&
    [states.MAP_CREATE_PTP_LINK, states.MAP_CREATE_ACCESS_POINT].includes(state)
  ) {
    return true;
  } else if (
    kind === 'subscriber_site' &&
    state === states.MAP_CREATE_PMP_LINK
  ) {
    return true;
  } else if (kind === 'access_point' && state === states.MAP_CREATE_MESH_LINK) {
    return true;
  }
  return false;
};

/**
 * Feature mouseover event handler
 */
export const onmouseover = (event) => {
  const dragger = new HandleDragging();
  if (!dragger.isDragging) {
    const target = event.target;
    const feature = target.feature;
    if (allowHighlight(feature.properties.kind)) {
      const style = getFeatureStyle(feature, true);
      if (!style) {
        return;
      }
      target.setStyle(style);
    }
  }
};

/**
 * Feature mouseout event handler
 */
export const onmouseout = (event) => {
  const target = event.target;
  const feature = target.feature;
  const style = getFeatureStyle(feature, false);
  if (!style) {
    return;
  }
  target.setStyle(style);
};
